// SystemList item names.
export const SHIPPING_TYPE_SYSTEM_LIST_NAME = "Shipping Type";
export const SHIPPING_TYPE_PREPAY_NAME = "Prepay";
export const SHIPPING_TYPE_COLLECT_NAME = "Collect / 3rd Party";

export const CARRIER_SHIPPING_TYPE_PROPERTY = "shippingType";
export const ADDRESS_TYPE_PROPERTY = "addressType";
export const ADDRESS_TYPE_ALTERNATIVE_SHIPPING = "AlternativeShipping";

// CustomerOrder custom properties (snapshot at submit).
export const ORDER_SHIPPING_TYPE_ID_PROPERTY = "shippingTypeId";
export const ORDER_SELECTED_CARRIER_NAME_PROPERTY = "selectedCarrierName";
export const ORDER_SELECTED_CARRIER_ACCOUNT_PROPERTY = "selectedCarrierAccountNumber";
export const ORDER_SHIPPING_INSTRUCTIONS_PROPERTY = "shippingInstructions";
export const ORDER_ALTERNATIVE_SHIPPING_BILL_TO_PROPERTY = "alternativeShippingBillToId";
// JSON-serialized AlternativeAddressDto, decorated by the IncludeAlternativeShippingAddressInGet{Cart,Order} backend handlers.
export const ORDER_ALTERNATIVE_SHIPPING_ADDRESS_PROPERTY = "alternativeShippingAddress";

// Account number buckets are namespaced by Carrier.Id (stable, edit-proof).
// "Other" is the only carrier identified by name: it never requires an account number.
export const CARRIER_KEY_OTHER = "Other";

// Validation
export const MAX_ACCOUNT_NUMBER_LENGTH = 50;
export const MAX_SHIPPING_INSTRUCTIONS_LENGTH = 250;
export const ACCOUNT_NUMBER_PATTERN = /^[A-Za-z0-9]+$/;
export const VISIBLE_DIGITS_ACCOUNT_NUMBER = 4;
export const TOOLTIP_SHIPPING_INSTRUCTIONS_LENGTH = 60;
